<template>
  <div>
    <college-score></college-score>
  </div>
</template>

<script>
import CollegeScore from './components/CollegeScore.vue'
import { mapState } from "vuex";
export default {
  name: '',
  computed: { ...mapState(["userInfo"]) },
  components: {
    CollegeScore
  },
  data() {
    return {
      equalScore: []
    };
  },
  watch: {
  },
  created() {
    this.$parent.cat = 2
  },
  methods: {
  },
};
</script>

<style scoped lang='less'>
.page-score {
  width: 1200px;

  padding: 30px 100px;
  margin: 0 auto;
  background: white;


  .userInfo {
    text-align: center;
    background-color: #FFFCF4;
    padding: 6px;
    margin-bottom: 40px;

    .info_2 {
      color: #1787e0;
      margin-right: 25px;
    }

    .info_3 {
      color: #1787e0;
      margin-left: 15px;
    }

    .info_4 {
      color: #a5a3a2;
    }
  }

}
</style>
